
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import { GroupSurveyExtension } from '../../../../backend/backendapi';
import CheckBox from './ExtraInfo/CheckBox.vue';
import TextInput from './ExtraInfo/TextInput.vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import { useTrigger } from '../../../../../util';

export type ExtraInfoEntry = {
  type: 'checkbox' | 'textInput';
  text: string;
  checked?: boolean;
  textInput?: string;
}

@Component({
  components: {
    CheckBox,
    TextInput,
  }, directives: {
    ObserveVisibility,
  },
})
export default class ExtraInfo extends Vue {
  @Prop({ required: true })
  readonly group!: GroupSurveyExtension;

  entries: ExtraInfoEntry[] = [];
  textLabelWidths = new Map<ExtraInfoEntry, number>(); //maps are not reactive in vue2, needs a trigger
  textLabelWidthsUpdateTrigger = false;

  get textLabelMinWidth(): number {
    useTrigger(this.textLabelWidthsUpdateTrigger);
    return Math.max(0, ...this.textLabelWidths.values());
  }
  
  clearTextLabelWidths(): void {
    if (this.textLabelWidths.size > 0) {
      this.textLabelWidths.clear();
      this.triggerTextLabelWidthUpdate();
    }
  }

  triggerTextLabelWidthUpdate(): void {
    this.textLabelWidthsUpdateTrigger = !this.textLabelWidthsUpdateTrigger;
  }

  updateTextLabelWidth(entry: ExtraInfoEntry, width: number) {
    if (!this.textLabelWidths.has(entry)
        || this.textLabelWidths.get(entry) != width) {
      this.textLabelWidths.set(entry, width);
      this.triggerTextLabelWidthUpdate();
    }
  }

  @Watch('group.extraInfoJson', { immediate: true })
  private onGroupExtraInfoJsonChanged(): void {
    this.entries.splice(0);
    this.entries.push(...JSON.parse(this.group.extraInfoJson));
  }

  @Watch('entries', { deep: true, immediate: true })
  private onEntriesChanged(): void {
    this.clearTextLabelWidths();

    const str = JSON.stringify(this.entries);
    if (str !== this.group.extraInfoJson) { //don't update if no change, prevents infinite vue update loop
      this.group.extraInfoJson = str;
    }
  }
}
